import { faker } from '@faker-js/faker';
import moment from 'moment';
import { generateChannel } from './test.methods';
import { Channel } from './types/channel.types';
import { EventItem } from './types/event.type';
import { FeedItem } from './types/feed.types';
import { GenreType, ReleaseItem } from './types/release.type';
import { SpaceMinifiedType } from './types/space.type';
import { ArtistDetails, TinyUser, UserProfile } from './types/userProfile';

const avatarImages = {
  jeymon:
    'https://pbs.twimg.com/profile_images/1553383384184786944/IzRve0M5_400x400.jpg',
  boslen:
    'https://pbs.twimg.com/profile_images/1486244856032677890/ZeJs6cfM_400x400.jpg',
  micky:
    'https://images.squarespace-cdn.com/content/v1/60b718f35c4e0648582b5179/a5201e60-8e9e-4c1b-b799-67192af5f968/Screen+Shot+2022-02-08+at+1.56.58+PM.png?format=500w',
  kelland:
    'https://www.chaosclubdigital.com/_next/image?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2F7o0fp5p4%2Fproduction%2F69ddfcfaea3dada2b9d9f9cafc654b648c76aa67-1620x1080.jpg&w=3840&q=75',
  elijah:
    'https://images.squarespace-cdn.com/content/v1/5b6c90494cde7a862c31a98c/2b5017bd-0d80-4e52-a984-469c018d26b9/277078749_157278030007008_3778090747901766200_n.jpg',
  earlsweatshirt:
    'https://media.pitchfork.com/photos/5db9ec85aef27a0009efa938/1:1/w_1944,h_1944,c_limit/Earl-Sweatshirt.jpeg',
  bakar:
    'https://i.discogs.com/ucHtbxIMVZ090rHyxTjEFkHAU_IquaSY552L_rO013s/rs:fit/g:sm/q:40/h:300/w:300/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTYxMjM5/NjgtMTY0NTc5MjAz/Mi0yOTUwLmpwZWc.jpeg',
  UMI: 'https://www.coupdemainmagazine.com/sites/default/files/article/16760/hero-16760-55900157.jpg',
  HAIM: 'https://www.rollingstone.com/wp-content/uploads/2018/06/haim-sisters-in-arms-2017-rolling-stone-feature-aac09581-eda4-48c2-a9e9-e6ae0ea7fe02.jpg',
  kotomi:
    'https://images.squarespace-cdn.com/content/v1/51636d31e4b0b470bd206acf/1614028297710-VRNYRFGNS6HLP26FXV0D/website-about.JPG?format=1000w',
  mindchatter:
    'https://edm.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTcyNTIzMjM5NjY5NTA3MTU1/img_2979.jpg',
};

export const genres: GenreType[] = [
  {
    title: 'hip-hop',
    thumbnail:
      'https://images.complex.com/images/fl_lossy,q_auto,w_910,dpr_auto/foe181rutfjtohb2j8jl/boslen',
  },
  {
    title: 'r&b',
    thumbnail:
      'https://lastfm.freetls.fastly.net/i/u/ar0/8d952a7e83017a62c33de2bd7b24f10b.jpg',
  },
  {
    title: 'experimental',
    thumbnail: 'https://alfitude.com/wp-content/uploads/2021/08/Jeymon.jpg',
  },
  {
    title: 'alternative',
    thumbnail:
      'https://pbs.twimg.com/ext_tw_video_thumb/1458245036173365253/pu/img/FJErlN6QeQRg31lA.jpg:large',
  },
  {
    title: 'EDM',
    thumbnail:
      'https://edmidentity.com/wp-content/uploads/2021/11/Kelland-Lullaby-Credit-TATUM-MACLEAN-scaled-e1638144893634.jpg',
  },
];

export const feedData: FeedItem[] = [
  {
    id: '3',
    avatar:
      'https://images.squarespace-cdn.com/content/v1/56c346b607eaa09d9189a870/1532647838688-NOUV2P377TEX73NS54ZB/CONTENT+LOGO.png?format=1500w',
    date: faker.date.recent(),
    link: 'https://flaunt.com/content/boslen-the-alt-hip-hop-star-putting-vancouver-on-the-map',
    source: 'Flaunt',
    sourceUrl: 'http://flaunt.com',
    tags: ['Boslen', 'Alt-Hip-Hop'],
    type: 'external',
    username: 'Flaunt',
    title: 'THE ALT-HIP-HOP STAR PUTTING VANCOUVER ON THE MAP',
    comment:
      "Boslen is a whole vibe, and we can't get enough. His sound is enticing and immediately catches your ear, unveiling...",
    imageUrl:
      'https://images.squarespace-cdn.com/content/v1/56c346b607eaa09d9189a870/1626150182122-CDGW7MU53TH6WS4WEHWE/Boslen+-+Cam+Corrado+-+Photo+Credit.jpg?format=2500w',
    category: 'news',
    bookmarked: false,
    artist: 'boslen',
  },
  // {
  //   id: '1',
  //   avatar:
  //     'https://trendyartideas.com/wp-content/uploads/2021/02/Geoff-Farnsworth-Painted-Portraits-of-People.jpg',
  //   date: moment('July 10 2022').toDate(),
  //   link: 'https://www.twitter.com/',
  //   reaction: 'indifferent',
  //   source: 'Twitter',
  //   sourceUrl: 'https://www.twitter.com/',
  //   tags: ['Boslen', 'Hip Hop'],
  //   type: 'external',
  //   username: 'ReasonableDbt101',
  //   bookmarked: false,
  //   comment:
  //     'Yo, mad facts is that Boslen is tripping! Like how can you delay the album 😟.',
  //   imageUrl: '',
  //   category: 'social',
  //   artist: 'boslen',
  // },
  {
    id: '2',
    avatar: avatarImages['kelland'],
    date: faker.date.recent(),
    link: '',
    reaction: null,
    source: 'holdr',
    tags: ['NFT', 'Upcoming Artists'],
    type: 'internal',
    username: 'kelland',
    comment: "I'm dropping a couple NFTs, stay tuned.",
    imageUrl: '',
    verified: true,
    category: 'holdr',
    bookmarked: false,
    artist: 'kelland',
  },

  {
    id: '4',
    avatar:
      'https://edmidentity.com/wp-content/uploads/2017/09/edmid_horizontal_full_white-500x95.png',
    date: faker.date.recent(),
    link: 'https://edmidentity.com/2021/11/28/edmid-fall-frequencies-2021-kelland/',
    source: 'EDM Identity',
    sourceUrl: 'https://www.edmidentity.com',
    tags: ['Kelland', 'EDM'],
    type: 'external',
    username: 'edmidentity',
    bookmarked: false,
    title: 'KELLAND SERENADES SOULS WITH THIS FALL MIX',
    comment:
      'After teaming up with Jay Isaiah on “Lullaby,” Kelland swung by to spin up a mix of his favorite tunes at the moment...',
    imageUrl:
      'https://edmidentity.com/wp-content/uploads/2021/11/Kelland-Lullaby-Credit-TATUM-MACLEAN-scaled-e1638144893634-1536x1149.jpg',
    category: 'news',
    artist: 'kelland',
  },
  {
    id: '5',
    avatar: avatarImages['elijah'],
    date: faker.date.recent(),
    link: 'https://bfan.link/revisions',
    source: 'holdr',
    tags: ['Alternative', 'New Music'],
    type: 'internal',
    username: 'elijahblond',
    bookmarked: false,
    title: '',
    comment: 'I just dropped my first EP called Re:visions, check it out!',
    imageUrl:
      'https://pbs.twimg.com/media/FO-7dNJVcAAWPOO?format=jpg&name=large',
    category: 'holdr',
    verified: true,
    artist: 'elijah blond',
  },
  {
    id: '6',
    avatar: avatarImages['jeymon'],
    date: faker.date.recent(),
    link: '',
    source: 'holdr',
    tags: ['Alternative', 'New Music'],
    type: 'internal',
    username: 'jeymon',
    title: '',
    comment: "Got a little something for y'all. Check it out on spotify NOW!!",
    imageUrl: '',
    category: 'holdr',
    verified: true,
    mediaItem: {
      source: 'Spotify',
      id: '73gI0MVJRdNY7ul02tHLnY?si=ZVqcI9ToRjiPiGDoDpuszA',
    },
    bookmarked: false,
    artist: 'jeymon',
  },
  {
    id: '7',
    avatar: avatarImages['elijah'],
    date: moment('July 10 2022').toDate(),
    link: 'https://twitter.com/elijahblond/status/1546353839854346240?s=20&t=3XAyu3TpRsGgF_X5p3tvGA',
    source: 'twitter',
    tags: ['Alternative', 'New Music'],
    type: 'external',
    username: 'elijahblond',
    title: '',
    sourceUrl: '/elijahblond',
    comment:
      'only frank ocean fans watch hours of an empty room on stream for MONTHS, or sit listening to a lecture on shrooms waiting for him to sing. Got us all in a chokehold fr',
    imageUrl: '',
    category: 'holdr',
    verified: true,
    bookmarked: false,
    artist: 'elijahblond',
  },
  {
    id: '8',
    avatar: avatarImages['boslen'],
    date: moment('August 6 2022').toDate(),
    link: 'https://twitter.com/Boslenofficial/status/1555891357180370944?s=20&t=7yEOgFEwxTpWFMW14N7Wng',
    source: 'twitter',
    tags: ['Hip Hop', 'New Music'],
    type: 'external',
    username: 'boslen',
    title: '',
    comment: 'lean into your strengths',
    imageUrl: '',
    sourceUrl: '/boslen',
    category: 'holdr',
    verified: true,
    bookmarked: false,
    artist: 'boslen',
  },
];

export const spacesData: SpaceMinifiedType[] = [
  {
    avatarUrl:
      'https://images.pexels.com/photos/333850/pexels-photo-333850.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    imageUrl:
      'https://images.complex.com/images/fl_lossy,q_auto,w_910,dpr_auto/foe181rutfjtohb2j8jl/boslen',
    title: "Bozzy's Gang",
    id: '1dasduihSDAsdnlkn',
    unreadMessages: 1,
    members: 100,
    description: 'We out here now!!',
  },
  {
    avatarUrl: avatarImages['micky'],
    imageUrl:
      'https://images.squarespace-cdn.com/content/v1/60b718f35c4e0648582b5179/a5201e60-8e9e-4c1b-b799-67192af5f968/Screen+Shot+2022-02-08+at+1.56.58+PM.png?format=500w',
    title: "Micky's Space",
    id: 'FdasduihSDAsdnlkn',
    unreadMessages: 1,
    members: 100,
    description: 'We out here now!!',
  },
  {
    avatarUrl: avatarImages['boslen'],
    imageUrl: 'https://pbs.twimg.com/media/FTychrvVEAAMf5c.jpg',
    title: 'Boslen Fan Club',
    id: '1dasduihSDAsdnlkM',
    unreadMessages: 1,
    members: 100,
    description: 'We out here now!!',
  },
  {
    avatarUrl: avatarImages['jeymon'],
    imageUrl: avatarImages['jeymon'],
    title: 'Jeymon',
    id: 'qdaEduihSDAsdnlkn',
    unreadMessages: 5,
    members: 100,
    description: "Man's just out here chattin' with fans",
  },
  {
    avatarUrl: avatarImages['kelland'],
    imageUrl: avatarImages['kelland'],
    title: 'Kelland',
    id: 'Msdlknli21AsdnlHkn',
    unreadMessages: 2,
    members: 100,
    description: "Let's go",
  },
  {
    avatarUrl: avatarImages['elijah'],
    imageUrl: avatarImages['elijah'],
    title: 'Elijah Blond',
    id: 'TcPlknli21AsdnlHkn',
    unreadMessages: 0,
    members: 100,
    description: 'Silk out now...',
  },
  {
    avatarUrl:
      'https://images.pexels.com/photos/3867522/pexels-photo-3867522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    imageUrl:
      'https://images.pexels.com/photos/3867522/pexels-photo-3867522.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    title: 'Underground Hip Hop',
    id: 'Msdlknli21Q67slHkn',
    unreadMessages: 100,
    members: 400,
    description: 'Anyone that is interested in underground hip hop',
  },
];

export const userProfileData: Array<UserProfile & ArtistDetails> = [
  {
    displayName: 'boslen',
    username: 'boslen',
    muted: false,
    avatarUrl: avatarImages['boslen'],
    bannerUrl: 'https://earmilk.com/wp-content/uploads/2021/03/boslenjpg.jpg',
    spotifyLink: 'https://open.spotify.com/artist/7mX72Bq2iXNr8fZdu23fQL',
    appleMusicLink: 'https://music.apple.com/us/artist/boslen/1292257629',
    youtubeLink: 'https://www.youtube.com/channel/UCqtuXVYM0_xBYhEQxCghFGw',
    trackers: '1.5K',
    collections: '9',
    verified: true,
    articles: '1',
  },
  {
    displayName: 'kelland',
    username: 'kelland',
    muted: false,
    avatarUrl: avatarImages['kelland'],
    bannerUrl:
      'https://www.chaosclubdigital.com/_next/image?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2F7o0fp5p4%2Fproduction%2F69ddfcfaea3dada2b9d9f9cafc654b648c76aa67-1620x1080.jpg&w=3840&q=75',
    spotifyLink: 'https://open.spotify.com/artist/7nZJ6x2Wj2suztg4H53GSf',
    appleMusicLink: 'https://music.apple.com/us/artist/kelland/1380531748',
    youtubeLink: 'https://www.youtube.com/channel/UCNsCEU7XWxXJ42LceWtgJ-w',
    trackers: '1K',
    collections: '7',
    verified: true,
    articles: '1',
  },
  {
    displayName: 'jeymon',
    username: 'jeymon',
    muted: false,
    avatarUrl: avatarImages['jeymon'],
    bannerUrl:
      'https://uploads-ssl.webflow.com/600764b039279f159ae570ef/6132501c2ec7bd0512f427c9_when-i%27m-with-you---jeymon.jpg',
    spotifyLink: 'https://open.spotify.com/artist/0lPy1fZZ773zFnM0JvKGww',
    appleMusicLink: 'https://music.apple.com/us/artist/jeymon/1530890703',
    youtubeLink: 'https://www.youtube.com/channel/UCYPsLnXKP075ZBY-fyIbnBA',
    trackers: '500',
    collections: '3',
    verified: true,
    articles: '0',
  },
  {
    displayName: 'elijah blond',
    username: 'elijahblond',
    muted: false,
    avatarUrl: avatarImages['elijah'],
    bannerUrl:
      'https://pbs.twimg.com/media/FO-7dNJVcAAWPOO?format=jpg&name=large',

    spotifyLink: 'https://open.spotify.com/artist/2VXLfW2EYO5KtZHCFQolnt',
    appleMusicLink: 'https://music.apple.com/us/artist/elijah-blond/1444837268',
    youtubeLink: 'https://www.youtube.com/channel/UChlw5yfgWdyHQEp-FupnQSQ',
    trackers: '200',
    collections: '2',
    verified: true,
    articles: '0',
  },
  {
    displayName: 'micky weekes',
    username: 'mickyweekes',
    muted: false,
    avatarUrl: avatarImages['micky'],
    bannerUrl:
      'https://www.chaosclubdigital.com/_next/image?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2F7o0fp5p4%2Fproduction%2F5ea139021c0f9fccc810e572a861eb10482a026f-4096x2730.jpg&w=3840&q=75',
    spotifyLink: 'https://open.spotify.com/artist/0ozOmFuSFqJMEdWKmgFfuw',
    appleMusicLink: 'https://music.apple.com/us/artist/micky-weekes/1576149371',
    youtubeLink: 'https://www.youtube.com/channel/UCD8NKyiHXkBRtkyM_cSLNuA',
    trackers: '150',
    collections: '2',
    verified: true,
    articles: '0',
  },
  {
    tracking: '5',
    avatarUrl:
      'https://images.pexels.com/photos/1482476/pexels-photo-1482476.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    username: 'the_music_plug',
    displayName: 'MUSIC 🔌',
    trackers: '0',
    collections: '0',
    articles: '0',
    bannerUrl:
      'https://cdn.sanity.io/images/nafsr4xw/production/25cc071e791f0e65ad69773a9d62af0a86e14553-2250x1500.webp',
  },
];

export const trendingArtists: {
  imageUrl: string;
  name: string;
  username: string;
}[] = [
  {
    imageUrl:
      'https://media.pitchfork.com/photos/5b8032e8a05ddb4ff66cd2cb/1:1/w_600/pink%20siifu_ensley.jpg',
    name: 'Pink Siifu',
    username: 'SiifuLand',
  },
  {
    imageUrl:
      'https://yt3.ggpht.com/ytc/AKedOLRUNTBYXRgZdJpZcd7DPW71jayNH4o-sc64ftd0Yg=s900-c-k-c0x00ffffff-no-rj',
    name: '#1 Dads',
    username: 'daddyshome',
  },
  {
    imageUrl:
      'https://media.pitchfork.com/photos/5929c37e69fc7814a47cd666/1:1/w_600/e73231fd.jpg',
    name: 'JMSN',
    username: 'jmsn',
  },
];

export const suggestedSpaces: {
  imageUrl: string;
  name: string;
  members: number;
}[] = [
  {
    imageUrl:
      'https://images.complex.com/complex/images/c_scale,f_auto,q_auto,w_1920/fl_lossy,pg_1/j5fdt1kca6z0lwesibyf/lead?fimg-ssr-default',
    name: 'Upcoming Artists',
    members: 117,
  },
  {
    imageUrl:
      'https://i.scdn.co/image/ab6761610000e5eb2161ef3bab0e5e922a1c297d',
    name: 'Gen Z Rappers',
    members: 59,
  },
  {
    imageUrl:
      'https://online.berklee.edu/takenote/wp-content/uploads/2018/09/aditya-chinchure-494048-unsplash.jpg',
    name: 'Electro Heads',
    members: 250,
  },
  {
    imageUrl:
      'https://images.saymedia-content.com/.image/ar_4:3%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:eco%2Cw_1200/MTc0NDkxNzA3MjAxODg5NjQw/100-best-rock-songs-of-the-90s.jpg',
    name: 'At the heart of Rock',
    members: 250,
  },
];

export const events: EventItem[] = [
  {
    id: 'FRdljlksdaASDF1',
    time: '7:00 PM',
    imageSrc:
      'https://i.scdn.co/image/ab6761610000e5ebe65c3be57b1039bed1927844',
    date: new Date('16 June 2022'),
    artist: {
      avatarUrl: avatarImages['micky'],
      username: 'mickyweekes',
    },
    description: 'Celebrating the release of my first album.',
    title: 'Valentine',
    lineUp: [],
    arena: 'Swangan Staduim',
    location: 'Burnaby, BC, Canada',
    eventType: 'Concert',
    tags: ['RnB', 'Upcoming Artists'],
    linkToTickets: 'https://www.ticketmaster.com',
  },
  {
    id: 'asdljlksdaASDD2',
    time: '7:00 PM',
    imageSrc:
      'https://www.respectmyregion.com/wp-content/uploads/2019/02/Screen-Shot-2019-02-22-at-10.45.05-AM-759x500.png',
    date: new Date('21 June 2022'),
    artist: {
      avatarUrl: avatarImages['elijah'],
      username: 'elijahblond',
    },
    description: 'The Revisions Tour Age: 19+',
    title: 'Revisions',
    lineUp: [],
    arena: 'The Commodore',
    location: 'Vancouver, BC, Canada',
    eventType: 'Concert',
    tags: ['Alternative', 'Upcoming Artists'],
    linkToTickets: 'https://www.ticketmaster.com/',
  },
  {
    id: 'asdljlksdaASDA2',
    time: '7:00 PM',
    imageSrc:
      'https://www.umusic.ca/wp-content/uploads/2022/03/boslen-gonzo-final-poster-scaled.jpg',
    date: new Date('20 July 2022'),
    artist: {
      avatarUrl: avatarImages['boslen'],
      username: 'boslen',
    },
    description: 'The Gonzo Tour Age: 19+',
    title: 'Gonzo',
    lineUp: [],
    arena: 'Lucky Bar',
    location: 'Victoria, BC, Canada',
    eventType: 'Concert',
    tags: ['Hip Hop', 'Upcoming Artists'],
    linkToTickets:
      'https://www.eventbrite.ca/e/boslen-the-gonzo-tour-victoria-tickets-301697895527?aff=aff0songkick&uid=&sk_eid=40311283',
  },
];

export const me = {
  avatar:
    'https://images.pexels.com/photos/1482476/pexels-photo-1482476.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  bannerUrl:
    'https://cdn.sanity.io/images/nafsr4xw/production/25cc071e791f0e65ad69773a9d62af0a86e14553-2250x1500.webp',
  username: 'the_music_plug',
  displayName: 'MUSIC 🔌',
  id: 'asdADasdjkhsdkasda',
  feedDefault: 'all',
  tracking: [
    { username: 'boslen' },
    { username: 'kelland' },
    { username: 'jeymon' },
    { username: 'elijahblond' },
  ],
};

const ADMINS: { [key: string]: TinyUser } = {
  boslen: { username: 'boslen', avatarUrl: avatarImages['boslen'] },
  kelland: { username: 'kelland', avatarUrl: avatarImages['kelland'] },
  micky: { username: 'mickyweekes', avatarUrl: avatarImages['micky'] },
  jeymon: { username: 'jeymon', avatarUrl: avatarImages['jeymon'] },
  elijah: { username: 'elijahblond', avatarUrl: avatarImages['elijah'] },
};

const CHANNEL = {
  bozzys_gang: {
    title: "Bozzy's gang",
    bgImage:
      'https://images.complex.com/images/fl_lossy,q_auto,w_910,dpr_auto/foe181rutfjtohb2j8jl/boslen',
    pinned:
      "This tour has been so AMAZING! I'm really grateful for the support, looking forward to meeting all my fans in Europe",
    description: 'Description coming soon',
    listenCount: 20,
    messageCount: 37,
    tags: ['Hip Hop', 'Upcoming Artists'],
  },
  elijah: {
    title: 'Elijah Blond',
    bgImage:
      'https://images.squarespace-cdn.com/content/v1/5b6c90494cde7a862c31a98c/3595c56b-c533-4d99-a35e-da1d5af93303/275784720_663504554931644_6654649049894455201_n.jpg?format=1000w',
    pinned:
      'Project drops at 9PM tomorrow for all my west coast listeners, and midnight for eastern timezone listeners 🖤',
    description: 'Description coming soon',
    listenCount: 25,
    messageCount: 30,
    tags: ['Alternative', 'Upcoming Artists'],
  },
  kelland: {
    title: 'Kelland',
    bgImage:
      'https://edmidentity.com/wp-content/uploads/2021/11/Kelland-Lullaby-Credit-TATUM-MACLEAN-scaled-e1638144893634.jpg',
    pinned:
      'So excited to be playing this coming week at the Lobby in Toronto.',
    description: 'Description coming soon',
    listenCount: 30,
    messageCount: 40,
    tags: ['Electronic', 'Upcoming Artists'],
  },
  jeymon: {
    title: 'Jeymon',
    bgImage: 'https://alfitude.com/wp-content/uploads/2021/08/Jeymon.jpg',
    pinned: 'FAH FAH FAH!!!',
    description: 'Description coming soon',
    listenCount: 25,
    messageCount: 30,
    tags: ['Alternative', 'Upcoming Artists'],
  },
  micky: {
    title: 'Micky Weekes',
    bgImage:
      'https://d5ik1gor6xydq.cloudfront.net/sellers/12200/1615481728281217.jpg',
    pinned: 'Void out now on all streaming platforms',
    description: 'Description coming soon',
    listenCount: 15,
    messageCount: 28,
    tags: ['RnB', 'Upcoming Artists'],
  },
  undergroundhiphop: {
    title: 'Underground Hip-hop',
    bgImage: 'https://farm3.staticflickr.com/2926/14263067700_532135b2f1_o.jpg',
    pinned:
      'We are only interested in underground hip hop. Anything else will get you annexed',
    description: '',
    listenCount: 15,
    messageCount: 28,
    tags: ['Hip Hop', 'Underground'],
  },
  newWave: {
    title: 'New Wave',
    bgImage:
      'https://static.stereogum.com/uploads/2022/05/Vory-Daylight-1654006209.jpg',
    pinned: "Where's the new wave? Everyone is welcome 🌻",
    description: '',
    listenCount: 15,
    messageCount: 28,
    tags: ['World', 'Upcoming Artists'],
  },
  brandNewMusic: {
    title: 'Brand New Music',
    bgImage:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d8/SAINt_JHN_2018.jpg/1200px-SAINt_JHN_2018.jpg',
    pinned:
      "What's new? We all about that in here. Anything old is definitely not appreciated 👎",
    description: '',
    listenCount: 35,
    messageCount: 20,
    tags: ['World', 'New Music'],
  },
  artistSpotlight: {
    title: 'Artist Spotlight',
    bgImage:
      'https://media.pitchfork.com/photos/627c1023d3c744a67a846260/master/pass/Kendrick-Lamar-Mr-Morale-And-The-Big-Steppers.jpg',
    pinned: '🔥🔥🔥',
    description: '',
    listenCount: 35,
    messageCount: 50,
    tags: ['World'],
  },
  nextBeatles: {
    title: 'Next Beatles',
    bgImage:
      'https://cdn.britannica.com/18/136518-050-CD0E49C6/The-Beatles-Ringo-Starr-Paul-McCartney-George.jpg',
    pinned: 'Rage on!',
    description: '',
    listenCount: 35,
    messageCount: 50,
    tags: ['Rock', 'Alternative Rock'],
  },
};

export const channels: Channel[] = [
  generateChannel(
    '1',
    CHANNEL['bozzys_gang'].title,
    ADMINS['boslen'],
    CHANNEL['bozzys_gang'].bgImage,
    CHANNEL['bozzys_gang'].pinned,
    CHANNEL['bozzys_gang'].description,
    CHANNEL['bozzys_gang'].listenCount,
    CHANNEL['bozzys_gang'].messageCount,
    true,
    CHANNEL['bozzys_gang'].tags,
    true,
    true
  ),
  generateChannel(
    '2',
    CHANNEL['kelland'].title,
    ADMINS['kelland'],
    CHANNEL['kelland'].bgImage,
    CHANNEL['kelland'].pinned,
    CHANNEL['kelland'].description,
    CHANNEL['kelland'].listenCount,
    CHANNEL['kelland'].messageCount,
    true,
    CHANNEL['kelland'].tags,
    true,
    true
  ),
  generateChannel(
    '3',
    CHANNEL['elijah'].title,
    ADMINS['elijah'],
    CHANNEL['elijah'].bgImage,
    CHANNEL['elijah'].pinned,
    CHANNEL['elijah'].description,
    CHANNEL['elijah'].listenCount,
    CHANNEL['elijah'].messageCount,
    true,
    CHANNEL['elijah'].tags,
    true,
    false
  ),
  generateChannel(
    '4',
    CHANNEL['jeymon'].title,
    ADMINS['jeymon'],
    CHANNEL['jeymon'].bgImage,
    CHANNEL['jeymon'].pinned,
    CHANNEL['jeymon'].description,
    CHANNEL['jeymon'].listenCount,
    CHANNEL['jeymon'].messageCount,
    true,
    CHANNEL['jeymon'].tags,
    true,
    true
  ),
  generateChannel(
    '5',
    CHANNEL['micky'].title,
    ADMINS['micky'],
    CHANNEL['micky'].bgImage,
    CHANNEL['micky'].pinned,
    CHANNEL['micky'].description,
    CHANNEL['micky'].listenCount,
    CHANNEL['micky'].messageCount,
    false,
    CHANNEL['micky'].tags,
    true,
    true
  ),
  generateChannel(
    '6',
    CHANNEL['newWave'].title,
    {
      username: faker.internet.userName(),
      avatarUrl: faker.internet.avatar(),
    },
    CHANNEL['newWave'].bgImage,
    CHANNEL['newWave'].pinned,
    CHANNEL['newWave'].description,
    CHANNEL['newWave'].listenCount,
    CHANNEL['newWave'].messageCount,
    true,
    CHANNEL['newWave'].tags,
    false,
    true
  ),
  generateChannel(
    '7',
    CHANNEL['undergroundhiphop'].title,
    {
      username: faker.internet.userName(),
      avatarUrl: faker.internet.avatar(),
    },
    CHANNEL['undergroundhiphop'].bgImage,
    CHANNEL['undergroundhiphop'].pinned,
    CHANNEL['undergroundhiphop'].description,
    CHANNEL['undergroundhiphop'].listenCount,
    CHANNEL['undergroundhiphop'].messageCount,
    false,
    CHANNEL['undergroundhiphop'].tags,
    false,
    false
  ),
  generateChannel(
    '8',
    CHANNEL['artistSpotlight'].title,
    {
      username: faker.internet.userName(),
      avatarUrl: faker.internet.avatar(),
    },
    CHANNEL['artistSpotlight'].bgImage,
    CHANNEL['artistSpotlight'].pinned,
    CHANNEL['artistSpotlight'].description,
    CHANNEL['artistSpotlight'].listenCount,
    CHANNEL['artistSpotlight'].messageCount,
    false,
    CHANNEL['artistSpotlight'].tags,
    false,
    false
  ),
  generateChannel(
    '9',
    CHANNEL['brandNewMusic'].title,
    {
      username: faker.internet.userName(),
      avatarUrl: faker.internet.avatar(),
    },
    CHANNEL['brandNewMusic'].bgImage,
    CHANNEL['brandNewMusic'].pinned,
    CHANNEL['brandNewMusic'].description,
    CHANNEL['brandNewMusic'].listenCount,
    CHANNEL['brandNewMusic'].messageCount,
    false,
    CHANNEL['brandNewMusic'].tags,
    false,
    true
  ),
  generateChannel(
    '10',
    CHANNEL['nextBeatles'].title,
    {
      username: faker.internet.userName(),
      avatarUrl: faker.internet.avatar(),
    },
    CHANNEL['nextBeatles'].bgImage,
    CHANNEL['nextBeatles'].pinned,
    CHANNEL['nextBeatles'].description,
    CHANNEL['nextBeatles'].listenCount,
    CHANNEL['nextBeatles'].messageCount,
    false,
    CHANNEL['nextBeatles'].tags,
    false,
    false
  ),
];

export const releases: ReleaseItem[] = [
  {
    id: '1',
    title: 'GONZO',
    cover:
      'https://images.genius.com/7a93b2b803872b206fa7163cab7f6b93.300x300x1.jpg',
    artist: {
      username: 'boslen',
      avatarUrl: avatarImages['boslen'],
      name: 'Boslen',
    },
    date: new Date('24 June 2022'),
    genre: 'hip-hop',
    spotify: {
      id: '1hBEXLboAWv9jyl2HpEtbw',
      type: 'album',
      link: 'https://open.spotify.com/album/1hBEXLboAWv9jyl2HpEtbw?si=sM21_ZM5SWy_c3yRgcHijQ',
    },
    links: {
      apple: '',
    },
  },
  {
    id: '2',
    title: 'FALLEN STAR (feat. Y2K)',
    cover:
      'https://www.umusic.ca/wp-content/uploads/2022/04/Fallen-Star-Artwork-scaled.jpg',
    artist: {
      username: 'boslen',
      avatarUrl: avatarImages['boslen'],
      name: 'Boslen',
    },
    date: new Date('28 April 2022'),
    genre: 'hip-hop',
    spotify: {
      id: '2e3XcLWd1SzB5jlJu53blm',
      type: 'track',
      link: 'https://open.spotify.com/track/2e3XcLWd1SzB5jlJu53blm?si=30c2bae86cab47f3',
    },
    links: {
      youtube: 'https://www.youtube.com/watch?v=R1JbYno7HEg',
    },
  },
  {
    id: '3',
    title: 'LEVELS',
    cover:
      'https://i1.sndcdn.com/artworks-e63nikoyaKyxTUI1-VgtRRw-t500x500.jpg',
    artist: {
      username: 'boslen',
      avatarUrl: avatarImages['boslen'],
      name: 'Boslen',
    },
    spotify: {
      id: '0BTKi9jL3v8WkkUXa329lE',
      type: 'track',
      link: 'https://open.spotify.com/track/0BTKi9jL3v8WkkUXa329lE?si=19dc9759cb644a5b',
    },
    date: new Date('18 February 2022'),
    genre: 'hip-hop',
    links: {
      youtube: 'https://www.youtube.com/watch?v=2D1-quT9E-s',
    },
  },
  {
    id: '4',
    title: 'FAH FAH FAH',
    cover: 'https://i.scdn.co/image/ab67616d0000b2739f1b682f862ad921dfa9fade',
    artist: {
      username: 'jeymon',
      avatarUrl: avatarImages['jeymon'],
      name: 'Jeymon',
    },

    date: new Date('12 April 2022'),
    genre: 'experimental',
    spotify: {
      id: '1DkVMUcHrWC7JcrTMjXoAi',
      type: 'track',
      link: 'https://open.spotify.com/track/1DkVMUcHrWC7JcrTMjXoAi?si=42268ee47978487f',
    },
    links: {
      youtube: 'https://www.youtube.com/watch?v=5AHvw46e3co',
    },
  },
  {
    id: '5',
    title: 'GOTTIT',
    cover: 'https://i.scdn.co/image/ab67616d0000b2733b9ac33752cbf1936000baf2',
    artist: {
      username: 'jeymon',
      avatarUrl: avatarImages['jeymon'],
      name: 'Jeymon',
    },
    date: new Date('4 March 2022'),
    genre: 'experimental',
    spotify: {
      id: '6n83UMjOasIGeOQR56dJFw',
      type: 'track',
      link: 'https://open.spotify.com/track/6n83UMjOasIGeOQR56dJFw?si=73f6c71935c2411f',
    },
  },
  {
    id: '6',
    title: 'Lovesick',
    cover:
      'https://m.media-amazon.com/images/I/519UD8zwZXL._UXNaN_FMjpg_QL85_.jpg',
    artist: {
      username: 'kelland',
      avatarUrl: avatarImages['kelland'],
      name: 'Kelland',
    },
    date: new Date('29 April 2022'),
    genre: 'EDM',
    spotify: {
      id: '7BsK668URclg7QKzr9TyD8',
      type: 'album',
      link: 'https://open.spotify.com/album/7BsK668URclg7QKzr9TyD8?si=CZnJ0v7bQ_-Wwp7rhK9cyQ',
    },
  },
  {
    id: '7',
    title: 'Void',
    cover:
      'https://i1.sndcdn.com/artworks-cDIQDPPTPARq3Hns-EhVOcg-t500x500.jpg',
    artist: {
      username: 'mickyweekes',
      avatarUrl: avatarImages['micky'],
      name: 'Micky Weekes',
    },
    date: new Date('3 June 2022'),
    genre: 'r&b',
    spotify: {
      id: '0YmrB6vW9d7PhX3KjwBE6l',
      type: 'track',
      link: 'https://open.spotify.com/track/0YmrB6vW9d7PhX3KjwBE6l?si=f61632f97cf641de',
    },
  },
  {
    id: '8',
    title: 'Revisions',
    cover: 'https://i.scdn.co/image/ab67616d00001e026913b3034f3ebfbeba26505b',
    artist: {
      username: 'elijahblond',
      avatarUrl: avatarImages['elijah'],
      name: 'Elijah Blond',
    },
    date: new Date('1 April 2022'),
    genre: 'alternative',
    spotify: {
      id: '2e7N2UuRBCFtzlbUQ520ye',
      type: 'album',
      link: 'https://open.spotify.com/album/2e7N2UuRBCFtzlbUQ520ye?si=aOMcvX0MTZ-qedR9nvNApg',
    },
  },
];

export const subscriptions: Array<TinyUser & { displayName: string }> = [
  {
    displayName: 'Boslen',
    username: 'boslen',
    avatarUrl: avatarImages['boslen'],
  },
  {
    displayName: 'Elijah Blond',
    username: 'elijahblond',
    avatarUrl: avatarImages['elijah'],
  },
  {
    displayName: 'Jeymon',
    username: 'jeymon',
    avatarUrl: avatarImages['jeymon'],
  },
  {
    displayName: 'Kelland',
    username: 'kelland',
    avatarUrl: avatarImages['kelland'],
  },
];

export const recommendedArtists: Array<TinyUser & { displayName: string }> = [
  {
    displayName: 'Micky Weekes',
    username: 'mickyweekes',
    avatarUrl: avatarImages['micky'],
  },
  {
    displayName: 'Earl Sweatshirt',
    username: 'earlsweatshirt',
    avatarUrl: avatarImages['earlsweatshirt'],
  },
  { displayName: 'Bakar', username: 'bakar', avatarUrl: avatarImages['bakar'] },
  { displayName: 'UMI', username: 'umi', avatarUrl: avatarImages['UMI'] },
  { displayName: 'HAIM', username: 'haim', avatarUrl: avatarImages['HAIM'] },
  {
    displayName: 'Kotomi',
    username: 'kotomi',
    avatarUrl: avatarImages['kotomi'],
  },
  {
    displayName: 'Mind Chatter',
    username: 'mindchatter',
    avatarUrl: avatarImages['mindchatter'],
  },
];
